(function () {
  window.addEventListener('load', function () {
    const ratings = document.querySelectorAll(
      '[data-oke-reviews-product-listing-rating]',
    );

    if (!ratings.length) {
      return;
    }

    ratings.forEach(function (rating) {
      if (rating.children.length) {
        for (let child of rating.children) {
          if (child.textContent.trim() == '') {
            rating.style.display = 'none';
          }
        }
      }
    });
  });

  // Add UTM params to product links in collections with '-paid' in the URL
  window.addEventListener('DOMContentLoaded', function () {
    function addUTMParams(productCardLinks, paramName, paramValue) {
      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set(paramName, paramValue);
        link.href = url.toString();
      });
    }

    if (document.querySelector('.js-collection-33-percent-off')) {
      const collectionGrid = document.querySelector(
        '.js-collection-33-percent-off .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      addUTMParams(productCardLinks, '_mv_lp_33', 'true');
    }

    if (document.querySelector('.js-collection-4week-plan')) {
      const collectionGrid = document.querySelector(
        '.js-collection-4week-plan .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      addUTMParams(productCardLinks, 'plan_type', '4w');
    }

    if (document.querySelector('.js-collection-25-percent-off')) {
      const collectionGrid = document.querySelector(
        '.js-collection-25-percent-off .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );
      addUTMParams(productCardLinks, '_mv_lp_25', 'true');
    }

    if (document.querySelector('.js-collection-30-percent-off')) {
      const collectionGrid = document.querySelector(
        '.js-collection-30-percent-off .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );
      addUTMParams(productCardLinks, '_mv_lp_30', 'true');
    }

    if (document.querySelector('.js-collection-additional-5')) {
      const collectionGrid = document.querySelector(
        '.js-collection-additional-5 .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      addUTMParams(productCardLinks, 'qtyselector', 'qtyselectorv1');
    }

    if (document.querySelector('.js-collection-paid')) {
      const collectionGrid = document.querySelector(
        '.js-collection-paid .multivitamins-collection__grid',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('status', 'paid');
        link.href = url.toString();
      });
    }

    if (document.querySelector('section.js-collection-patients')) {
      const collectionGrid = document.querySelector(
        'section.js-collection-patients .collection__products',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.collection__products__item a',
      );

      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('status', 'patients');
        link.href = url.toString();
      });
    }

    function addHeroImageParams() {
      console.log('addHeroImageParams');
      const heroLinks = document.querySelectorAll(
        '.multivitamins-collection__grid a',
      );

      if (window.location.search.toLowerCase().includes('heroimage=herov2')) {
        heroLinks.forEach((link) => {
          const url = new URL(link.href);
          url.searchParams.set('heroimage', 'herov2');
          link.href = url.toString();
        });
      }
      if (window.location.search.toLowerCase().includes('heroimage=herov3')) {
        heroLinks.forEach((link) => {
          const url = new URL(link.href);
          url.searchParams.set('heroimage', 'herov3');
          link.href = url.toString();
        });
      }
    }

    function getOtpSpParam() {
      const sp = new URLSearchParams(window.location.search).get('sp');
      return sp === 'otp' || sp === 'otp2' ? sp : null;
    }

    function addOtpParam() {
      const sp = getOtpSpParam();
      if (!sp) return;

      document
        .querySelectorAll('.multivitamins-collection__grid-item a')
        .forEach((link) => {
          const url = new URL(link.href);
          url.searchParams.set('sp', sp);
          link.href = url.toString();
        });
    }

    function addOtpOfferParam() {
      const otpOffer = new URLSearchParams(window.location.search).get('otpoffer');
      if (!otpOffer) return;

      document
        .querySelectorAll('.multivitamins-collection__grid-item a')
        .forEach((link) => {
          const url = new URL(link.href);
          url.searchParams.set('otpoffer', otpOffer);
          link.href = url.toString();
        });
    }

    function applyOtpComparePrices() {
      if (!getOtpSpParam()) return;

      document.querySelectorAll('[data-otp-compare-price]').forEach((el) => {
        const cents = parseInt(el.dataset.otpComparePrice, 10);
        if (Number.isNaN(cents) || typeof Shopify?.formatMoney !== 'function')
          return;
        el.textContent = Shopify.formatMoney(cents);
      });
    }

    addHeroImageParams();
    addOtpParam();
    addOtpOfferParam();
    applyOtpComparePrices();
    window.addEventListener('load', addOtpParam);
    window.addEventListener('load', addOtpOfferParam);
    window.addEventListener('load', applyOtpComparePrices);

    // Sticky filter container — detect active header dynamically
    var filterContainer = document.querySelector('.multivitamins-collection__filter-container');
    if (filterContainer) {
      var parent = filterContainer.parentElement;

      function findActiveHeader() {
        var candidates = document.querySelectorAll(
          'sticky-header-old, sticky-header, .header-wrapper, [data-header]'
        );
        for (var i = 0; i < candidates.length; i++) {
          if (candidates[i].getBoundingClientRect().height > 0) return candidates[i];
        }
        return document.querySelector('header');
      }

      function updateStickyFilter() {
        var header = findActiveHeader();
        var headerHeight = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        var parentRect = parent.getBoundingClientRect();

        filterContainer.style.setProperty('--header-height', headerHeight + 'px');
        filterContainer.classList.toggle('needs-translation', parentRect.top <= 0);
      }

      window.addEventListener('scroll', updateStickyFilter, { passive: true });
      window.addEventListener('resize', updateStickyFilter);
      updateStickyFilter();
    }
  });
})();